import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Map = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="map icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M56 3H4C3.44772 3 3 3.44772 3 4V56C3 56.5523 3.44772 57 4 57H53L56 60H4C1.79086 60 0 58.2091 0 56V4C0 1.79086 1.79086 0 4 0H56C58.2091 0 60 1.79086 60 4V56L57 53V4C57 3.44772 56.5523 3 56 3Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.5 51C46.299 51 51 46.299 51 40.5C51 34.701 46.299 30 40.5 30C34.701 30 30 34.701 30 40.5C30 46.299 34.701 51 40.5 51ZM40.5 54C47.9558 54 54 47.9558 54 40.5C54 33.0442 47.9558 27 40.5 27C33.0442 27 27 33.0442 27 40.5C27 47.9558 33.0442 54 40.5 54Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.2677 2.04701L9.95298 59.4224L7.35861 57.916L40.6734 0.540603L43.2677 2.04701Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1659 10.311L9.70722 31.7675L7.11285 30.2611L19.5715 8.80456L22.1659 10.311Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.4544 39.464L8.9407e-06 28.6523L1.40195 26L21.8563 36.8118L20.4544 39.464Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.2844 24.9028L35.9543 13.0995L37.3562 10.4473L59.6863 22.2505L58.2844 24.9028Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5145 17.9672L3.81184 2.79559L5.21378 0.143311L33.9165 15.3149L32.5145 17.9672Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M33.8998 31.7708L26.9504 28.0975L28.3523 25.4452L35.3017 29.1185L33.8998 31.7708Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.0607 49.2127L58.5571 60.7091C59.1429 61.2949 60.0927 61.2949 60.6785 60.7091C61.2642 60.1234 61.2642 59.1736 60.6785 58.5878L49.182 47.0913L51.3033 44.97L62.7998 56.4665C64.5571 58.2239 64.5571 61.0731 62.7998 62.8305C61.0424 64.5878 58.1932 64.5878 56.4358 62.8305L44.9393 51.334L47.0607 49.2127Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <circle
      cx="12"
      cy="15"
      r="6"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <circle
      cx="42"
      cy="11"
      r="6"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <circle
      cx="20"
      cy="48"
      r="6"
      className={`color-iconBrand-default ${pathClass}`}
    />
    <circle
      cx="12"
      cy="15"
      r="3"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <circle
      cx="42"
      cy="11"
      r="3"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <circle
      cx="20"
      cy="48"
      r="3"
      className={`color-iconPrimary-disabled ${pathClass}`}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.5 35C38.8092 35 37.2977 35.7611 36.2864 36.9649C35.7535 37.5992 34.8074 37.6814 34.1731 37.1485C33.5388 36.6156 33.4565 35.6694 33.9894 35.0351C35.5463 33.1819 37.8859 32 40.5 32C43.1142 32 45.4538 33.1819 47.0106 35.0351C47.5435 35.6694 47.4613 36.6156 46.827 37.1485C46.1927 37.6814 45.2465 37.5992 44.7136 36.9649C43.7024 35.7611 42.1908 35 40.5 35Z"
      className={`color-iconBrand-default ${pathClass}`}
    />
  </svg>
)
